import { DependencyList, useEffect, useRef, useState } from "react";

type OffsetOptions = { offsetTop?: number; offsetBottom?: number };
export function useScrollEndListener<T extends HTMLElement>({
  offsetTop = 0,
  offsetBottom = 0,
}: OffsetOptions = {}) {
  const containerRef = useRef<T>(null);
  const [reachedTop, setReachedTop] = useState(false);
  const [reachedBottom, setReachedBottom] = useState(false);
  useEffect(() => {
    if (!!containerRef.current) {
      const handleScroll = () => {
        const { scrollTop, scrollHeight, clientHeight } = containerRef.current!;
        const scrollBottom = scrollHeight - clientHeight - scrollTop;
        if (scrollBottom <= offsetBottom) {
          setReachedBottom(true);
        } else if (scrollTop <= offsetTop) {
          setReachedTop(true);
        } else {
          setReachedTop(false);
          setReachedBottom(false);
        }
      };
      containerRef.current.addEventListener("scroll", handleScroll);
      return () =>
        containerRef.current?.removeEventListener("scroll", handleScroll);
    }
  }, [containerRef.current]);
  return [containerRef, reachedTop, reachedBottom] as const;
}
